import MuiAccordionDetails, {
  AccordionDetailsProps as MuiAccordionDetailsProps,
} from "@mui/material/AccordionDetails";

type AccordionDetailsProps = Pick<
  MuiAccordionDetailsProps,
  "children" | "className"
>;

export const AccordionDetails: React.FC<AccordionDetailsProps> = (props) => {
  return (
    <MuiAccordionDetails
      sx={{
        backgroundColor: "transparent",
        padding: "16px 0",
        borderBottom: "none",
      }}
      {...props}
    />
  );
};
